import React from 'react';

export default function Actions({ attr, expanded, toggle, openTermModal, openAttributeEditModal }) {
  return (
    <div className="flex items-center gap-3">
      <button onClick={toggle} className="text-sm text-indigo-600 hover:text-indigo-900 underline">{expanded ? 'Hide terms' : 'Show terms'}</button>
      {typeof openAttributeEditModal === 'function' ? (
        <button type="button" onClick={() => openAttributeEditModal(attr)} className="text-sm text-red-600 hover:text-red-900 underline bg-transparent p-0">Edit</button>
      ) : (
        <a className="text-sm text-red-600 hover:text-red-900 underline" href={`${attr.attribute_link}&edit=${attr.attribute_id}`} target="_blank" rel="noreferrer">Edit</a>
      )}
      <button type="button" onClick={openTermModal} className="text-sm text-indigo-600 hover:bg-theme200 bg-theme text-white py-0.5 px-3 rounded">Add Term</button>
    </div>
  );
}
